import React, {useState, useEffect, useRef, useCallback, createRef} from "react";
import {inject, observer} from 'mobx-react';
import {db} from '../../../../firebase/Firebase';
import DataGrid, {
    Column,
    Pager,
    Paging,
    Export,
    SearchPanel,
    Sorting,
} from 'devextreme-react/data-grid';
import {useSnackbar} from 'notistack';
import ExcelJS from 'exceljs';
import saveAs from 'file-saver';
import {exportDataGrid} from 'devextreme/excel_exporter';
import format from 'date-fns/format'
import {es} from "date-fns/locale";
import axios from "axios"
import ComponentLoadPanel from "../../../../palette/LoadPanel";
import VerticalSpace from "../../../../palette/VerticalSpace";
import {Animated} from "react-animated-css";
import HeaderPage from "../../../../palette/HeaderPage";
import {FormContainer, LayoutChild} from "../../../../palette/Palette";
import {ErrorMessage, NotiStackInfo} from "../../../../palette/NotiStackInfo";
import {jsPDF} from "jspdf";
import {exportDataGrid as exportDataGridToPdf} from "devextreme/pdf_exporter";
import Alerts from "../../../../palette/Alerts";
import Load from "../../../../palette/Load";

const date = new Date();

const datesObject = {
    since: null,
    until: null
}

const headers = {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
};

const url = 'https://travel-status-easi4xatjq-uc.a.run.app/travel-status';
//const url = 'http://192.168.100.3:5000/travel-status';


const useMountedState = () => {
    const mountedRef = useRef(false)
    const isMounted = useCallback(() => mountedRef.current, [])

    useEffect(() => {
        mountedRef.current = true

        return () => {
            mountedRef.current = false
        }
    }, [])

    return isMounted
}

function TravelStatus(props) {

    const {DataStore} = props;

    const {companyName, idCompany} = DataStore

    const [loading, setLoading] = useState(false)
    const [travelStatus, setTravelStatus] = useState(null)
    const [dates, setDates] = useState(datesObject);
    const [datesStr, setDatesStr] = useState(datesObject);
    const [showPanel, setShowPanel] = useState(false);
    const [textGrid, setTextGrid] = useState('Esperando datos...');
    const [trigger, setTrigger] = useState(false)

    const {enqueueSnackbar} = useSnackbar();
    const isMounted = useMountedState()
    const dataGridRef = createRef();

    const mainPath = db.collection(companyName).doc(idCompany).collection('TravelStatus')
    const year = format(date, 'yyyy');
    const month = format(date, 'MMMM', {locale: es});
    const upperMonth = month.charAt(0).toUpperCase() + month.slice(1)

    useEffect(() => {
        const GetTravelStatus = async () => {
            const dataArray = []
            let ID = 0
            await mainPath.doc(year).collection(month).get()
                .then(querySnapshot => {
                    ID = ID + 1
                    querySnapshot.forEach(doc => {
                        const obj = {
                            ...doc.data(),
                            docId: doc.id,
                            ID: ID,
                            plateNumber: doc.data().plateNumber.toUpperCase()
                        };
                        dataArray.push(obj);
                    })
                    const orderArray = dataArray.sort((a, b) => (a['status'] < b['status']) ? 1 : -1)
                    setTravelStatus([...orderArray])

                    setLoading(true)
                    dataArray.length === 0 && setTextGrid('Esperando datos...')
                })
        }

        if (isMounted()) {
            GetTravelStatus().catch(() => {
                NotiStackInfo(ErrorMessage(), 'error', enqueueSnackbar)
            })
        }
    }, [isMounted, trigger])

    const onValueChanged = async (value, key) => {
        if (value) {
            const date = format(value, 'yyyy-MM-dd')
            setDates({...dates, [key]: value})
            setDatesStr({...datesStr, [key]: date})
            const search = {...datesStr, [key]: date}

            if (search.until && search.since) {
                if (search.until < search.since) {
                    NotiStackInfo('La fecha final no puede ser anterior a la fecha actual', 'error',
                        enqueueSnackbar)
                    return
                }

                setShowPanel(true)

                const dateSince = Date.parse(search.since)
                const dateUntil = Date.parse(search.until)

                const yearSince = format(dateSince, 'yyyy')
                const yearUntil = format(dateUntil, 'yyyy')

                if (yearSince === yearUntil) {
                    const data = {
                        search,
                        companyName: companyName,
                        idCompany: idCompany,
                        sameYear: true
                    }

                    await axios.post(url, data, {headers: headers})
                        .then(res => {
                            setTravelStatus(res.data.result)
                            res.data.result.length === 0 && setTextGrid('No existe historial para estas fechas...')
                            setShowPanel(false)
                        }).catch(() => {
                            setTravelStatus([])
                            setShowPanel(false)
                            NotiStackInfo(ErrorMessage(), 'error', enqueueSnackbar)
                        })

                } else {
                    const data = {
                        search,
                        companyName: companyName,
                        idCompany: idCompany,
                        sameYear: false
                    }
                    await axios.post(url, data, {headers: headers})
                        .then(res => {
                            setTravelStatus(res.data.result)
                            res.data.result.length === 0 && setTextGrid('No existe historial para estas fechas...')
                            setShowPanel(false)
                        }).catch(() => {
                            setTravelStatus([])
                            setShowPanel(false)
                            NotiStackInfo(ErrorMessage(), 'error', enqueueSnackbar)
                        })
                }
            }
        }
        if (value == null) {
            setTrigger(!trigger)
            setDates(datesObject)
        }
    }

    const onToolbarPreparing = (e) => {

        const {toolbarOptions} = e
        const {items} = toolbarOptions

        items.unshift({
            location: 'before',
            widget: 'dxButton',
            options: {
                width: 120,
                text: 'Imprimir',
                elementAttr: {id: 'btn-pdf'},
                icon: 'far fa-file-pdf',
                onClick: exportGridPDF
            }
        })

        items.unshift({
                location: 'before',
                widget: 'dxDateBox',
                options: {
                    width: 212,
                    placeholder: 'Hasta',
                    showClearButton: true,
                    value: dates.until,
                    onValueChanged: (e) => onValueChanged(e.value, 'until')
                }
            },
        )

        items.unshift({
                location: 'before',
                widget: 'dxDateBox',
                options: {
                    width: 212,
                    placeholder: 'Desde',
                    showClearButton: true,
                    value: dates.since,
                    onValueChanged: (e) => onValueChanged(e.value, 'since')
                }
            },
        )
    }

    function exportGridPDF() {
        const pdfDoc = new jsPDF('l', 'pt', "a4");
        const dataGrid = dataGridRef.current.instance;

        const options = {
            jsPDFDocument: pdfDoc,
            component: dataGrid,
            autoTableOptions: {
                margin: {top: 60, left: 15}
            },
        }

        exportDataGridToPdf(options).then(() => {
            pdfDoc.setFontSize(12);
            const pageCount = pdfDoc.internal.getNumberOfPages();
            for (let i = 1; i <= pageCount; i++) {
                pdfDoc.setPage(i);
                const pageSize = pdfDoc.internal.pageSize;
                const pageWidth = pageSize.width ? pageSize.width : pageSize.getWidth();
                const pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight();
                const header = companyName;
                const report = `Reporte : Estado de viajes`
                const date = `Fecha : ${format(new Date(), 'yyyy-MM-dd')}`
                const footer = `Pagina ${i} de ${pageCount}`;

                // Header
                pdfDoc.setFontSize(14)
                pdfDoc.setFont('helvetica', '', 'bold')
                pdfDoc.text(header, 15, 15, {baseline: 'top'});
                pdfDoc.setFontSize(12)
                pdfDoc.setFont('helvetica', '', 500)
                pdfDoc.text(report, 15, 30, {baseline: 'top'});
                pdfDoc.setFontSize(8)
                pdfDoc.setFont('helvetica', '', 500)
                pdfDoc.text(date, 15, 45, {baseline: 'top'});
                // Footer
                pdfDoc.setFontSize(8)
                pdfDoc.text(footer, pageWidth / 2 - (pdfDoc.getTextWidth(footer) / 2), pageHeight - 15, {baseline: 'bottom'});

            }
        }).then(() => {
            pdfDoc.save('Estado-viajes.pdf');
        });
    }

    const onExporting = (e) => {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Main sheet');
        exportDataGrid({
            component: e.component,
            worksheet: worksheet,
            autoFilterEnabled: true,
            topLeftCell: {row: 6, column: 2},
            customizeCell: ({gridCell, excelCell}) => {

                if (gridCell.rowType === 'data') {
                    if (excelCell.row % 2 === 0) {
                        excelCell.fill = {
                            type: 'pattern',
                            pattern: 'solid',
                            fgColor: {argb: 'C6EFCE'},
                            bgColor: {argb: 'C6EFCE'},
                        };
                    }
                }
            },
        }).then(function () {
            const headerCompany = worksheet.getRow(2);
            const headerReport = worksheet.getRow(3);
            const headerDate = worksheet.getRow(4);

            headerCompany.getCell(2).value = companyName;
            headerCompany.getCell(2).font = {bold: true, size: 16, underline: 'double'};

            headerReport.getCell(2).value = `Reporte : Estado de viajes`;
            headerReport.getCell(2).font = {name: 'Segoe UI Light', size: 12, bold: 600};
            headerReport.getCell(2).alignment = {horizontal: 'left'};

            headerDate.getCell(2).value = `Fecha : ${format(new Date(), 'yyyy-MM-dd')}`;
            headerDate.getCell(2).font = {name: 'Segoe UI Light', size: 8, bold: 700};
            headerDate.getCell(2).alignment = {horizontal: 'left'};

            workbook.xlsx.writeBuffer().then(function (buffer) {
                saveAs(new Blob([buffer], {type: 'application/octet-stream'}), 'Estado-viajes.xlsx');
            });
        });
        e.cancel = true;
    };

    return (
        <>
            <VerticalSpace space={30}/>
            <Animated animationIn="fadeIn" animationOut="slideOutUp" isVisible={true}>
                <div className="grid-container">
                    <HeaderPage icon={'far fa-compass'} text={'Estado de viajes'} load={loading}
                                textLoad={'Cargando....'}/>
                    <FormContainer>
                        <DataGrid
                            id="types-vehicles"
                            ref={dataGridRef}
                            dataSource={travelStatus}
                            keyExpr="ID"
                            allowColumnReordering={true}
                            showBorders={true}
                            onToolbarPreparing={onToolbarPreparing}
                            rowAlternationEnabled={true}
                            noDataText={textGrid}
                            onExporting={onExporting}
                        >
                            <SearchPanel visible={true}
                                         width={240}
                                         placeholder="Buscar"/>
                            <Export enabled={true} texts={{exportAll: 'Excel'}}/>
                            <Sorting mode="multiple"/>
                            <Paging defaultPageSize={20}/>
                            <Pager
                                showPageSizeSelector={true}
                                allowedPageSizes={[10, 20, 30]}
                                showInfo={true}/>
                            />
                            <Column dataField="driver" alignment={'center'} caption={'Conductor'}/>
                            <Column dataField="plateNumber" alignment={'center'} caption={'Placa'}/>
                            <Column dataField="contactNumber" alignment={'center'} caption={'Contacto'}/>
                            <Column dataField="origen" alignment={'center'} caption={'Origen'}/>
                            <Column dataField="destination" alignment={'center'} caption={'Destino'}/>
                            <Column dataField="date" alignment={'center'} caption={'Fecha'} defaultSortOrder="asc"/>
                            <Column dataField="hour" alignment={'center'} caption={'Hora'} width={70}/>
                            <Column dataField="numberPassengers" alignment={'center'} caption={'No. pasajeros'}/>
                            <Column dataField="totalParcels" alignment={'center'} caption={'No. encomiendas'}/>
                            <Column dataField="onBoard" alignment={'center'} caption={'A bordo'} width={70}/>
                            <Column dataField="status" cellRender={CellRender} alignment={'center'} caption={'Estado'}/>
                        </DataGrid>
                    </FormContainer>
                    <ComponentLoadPanel showLoadPanel={showPanel} message={'Consultando. . .'} time={3000}/>
                </div>
            </Animated>

            {travelStatus === null &&
            <LayoutChild color='transparent' percent={95} margin='auto' top={10}>
                <Alerts severity='warning' body={`Aun no existen datos para el mes de ${upperMonth}`}/>
            </LayoutChild>
            }

            {travelStatus === null && <Load textLoad={'Cargando...'}/>}
        </>
    )
}

export default inject('DataStore', 'ControlStore')(observer(TravelStatus));

function CellRender(cellData) {
    const status = cellData.data.status

    return (
        <div>
            {status === 'Cancelado' &&
            <span style={{color: 'red'}}>{status}</span>
            }
            {status === 'Programado' &&
            <span style={{color: '#0277BD'}}>{status}</span>
            }

            {status === 'Completado' &&
            <span style={{color: 'green'}}>{status}</span>
            }

            {status === 'En curso' &&
            <span style={{color: '#388E3C'}}>{status}</span>
            }
            {status === 'Finalizado' &&
            <span style={{color: 'green'}}>{status}</span>
            }

            {status === 'Finalizado(Obs.)' &&
            <span style={{color: '#2E7D32'}}>{status}</span>
            }

            {status === 'Pendiente' &&
            <span style={{color: 'gray'}}>{status}</span>
            }

        </div>
    );
}